import React, { useState } from 'react';
import { Spinner, Flex, Grid } from '@theme-ui/components';
import PropType from 'prop-types';
import _ from 'lodash';
import { Button, InputBox } from '../atoms';
import { colors } from '../../styles/theme';
import { saveForm } from '../hubspot/hsAPI';
import { getButtonId } from '../../utils/common';
import { validatePhone, validateEmail } from '../../utils/form-validator';

const Input = ({
	label,
	name,
	value,
	maxlength,
	error,
	onChange,
	...props
}) => (
	<InputBox
		label={label}
		isRequired={true}
		labelColor={colors.black}
		errorColor={colors.errorMain}
		name={name}
		value={value}
		maxlength={maxlength}
		customStyles={{
		width: '100%',
	}}
		error={error}
		onChange={onChange}
		{...props}
	/>
);

export const GlassDemoForm = ({
	formCode,
	pageCode,
	pageName,
	pageUrl,
	regionCode,
	searchParams,
	setHideForm,
	setIsSuccess,
	recaptchaRef,
}) => {
	const utm_source = searchParams['utm_source'];
	const utm_medium = searchParams['utm_medium'];
	const utm_campaign = searchParams['utm_campaign'];

	const [name, setName] = useState('');
	const [email, setEmail] = useState('');
	const [mobileNumber, setMobileNumber] = useState('');
	const [company, setCompany] = useState('');

	const [error, setError] = useState({});
	const [processing, setProcessing] = useState(false);
	const phoneNoLength = regionCode === "ME" ? 15 : 10;

	const validateForm = () => {
		let error = {};
		const emailErr = validateEmail(email);
		emailErr && (error["email"] = emailErr);
		if(regionCode === "IN") {
			const phoneErr = validatePhone(mobileNumber);
			phoneErr && (error["mobile"] = phoneErr);
		}
		return error;
	};

	const handleClick = async (e) => {
		e.preventDefault();
		setError({});
		setProcessing(true);

		const formErrors = validateForm();
		if (!_.isEmpty(formErrors)) {
			setError(formErrors);
			setProcessing(false);
			return;
		}

		if (recaptchaRef && recaptchaRef.current) {
			let captcha = '';
			recaptchaRef.current.reset();
			captcha = await recaptchaRef.current.executeAsync();
			const payload = {
				mat_full_name: name,
				mat_email: email,
				mat_phone: mobileNumber,
				mat_company: company,
				page_code: pageCode,
				page_name: pageName,
				page_url: pageUrl,
				form_code: formCode,
				invisible_recaptcha: true,
				captcha,
				utm_campaign,
				utm_medium,
				utm_source,
			};
			if (captcha) {
				saveForm(
					payload,
					(response) => {
						setProcessing(false);
						setHideForm(true);
						setIsSuccess(true);
					},
					(error) => {
						setProcessing(false);
						if (
							error.response &&
							error.response.status == 400 &&
							error.response.data.invalid_email
						) {
							setError((prev) => ({
								...prev,
								email: error.response.data.invalid_email,
							}));
						} else {
							setHideForm(true);
							setIsSuccess(false);
						}
					}
				);
			} else {
				setProcessing(false);
				setHideForm(true);
				setIsSuccess(false);
			}
		} else {
			setProcessing(false);
			setHideForm(true);
			setIsSuccess(false);
		}
	};
	const handleOnChange = (e) => {
		regionCode === "IN" 
			? setMobileNumber(e.target.value.replace(/\D/g, '')) 
			: setMobileNumber(e.target.value.replace(/[^0-9+ ]/g, ''))
	}

	return (
		<Flex
			className="glass300"
			sx={styles.container}
			as='form'
			onSubmit={handleClick}
		>
			<Grid
				sx={styles.subContainer}
				columns={[1, 1, 1, 2]}
			>
				<Input
					type='text'
					label='Full Name'
					value={name}
					name='name'
					maxlength='100'
					error={error?.name}
					onChange={(e) => setName(e.target.value)}
				/>
				<Input
					type='text'
					label='Mobile Number'
					value={mobileNumber}
					name='mobileNumber'
					maxlength={phoneNoLength}
					error={error?.mobile}
					onChange={handleOnChange}
				/>
				<Input
					label='Business Email'
					name='email'
					value={email}
					maxlength={100}
					error={error?.email}
					onChange={(e) => setEmail(e.target.value)}
				/>
				<Input
					type='text'
					label='Company Name'
					value={company}
					name='company'
					maxlength={200}
					error={error?.company}
					onChange={(e) => setCompany(e.target.value)}
				/>
			</Grid>
			
			{processing ? (
				<Spinner
					color={colors.primaryMain}
					size={58}
				/>
			) : (
				<Button
					id={getButtonId(`${pageCode}_request_demo`, regionCode)}
					variant="filled"
					size='large'
					disabled={!email || !name || !mobileNumber || !company}
				>
					Request Demo
				</Button>
			)}
		</Flex>
	);
};

const styles = {
	container: {
		p: ['1.5rem', '1.5rem', 5, 5],
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
    width: "100%"
	},
	subContainer: {
		columnGap: '1.5rem',
		rowGap: '1rem',
		mb: '3rem',
    width: "100%"
	},
};

GlassDemoForm.propTypes = {
	pageCode: PropType.string,
	pageName: PropType.string,
	pageUrl: PropType.string,
	regionCode: PropType.string,
	searchParams: PropType.object,
	setHideForm: PropType.func,
	setIsSuccess: PropType.func,
	recaptchaRef: PropType.any
};

Input.propTypes = {
	label: PropType.string,
	name: PropType.string,
	value: PropType.string,
	maxlength: PropType.number,
	error: PropType.string,
	onChange: PropType.func,
};

export default GlassDemoForm;
